import api from './api';

export default {
  getAll() {
    return api.get('/partners');
  },
  getById(id: number) {
    return api.get(`/partners/${id}`);
  },
  create(data: FormData) {
    return api.post('/partners', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  update(id: number, data: FormData) {
    // Spoofing PUT using POST for Laravel multipart/form-data support
    data.append('_method', 'PUT');
    return api.post(`/partners/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  delete(id: number) {
    return api.delete(`/partners/${id}`);
  }
};
